import React from 'react';

/**
 * Wrapper for every page section. Ensures consistent separation, scroll-margin, and semantics.
 * Use for: Hero, About, Experience, Projects, Education.
 */
const Section = React.forwardRef(({ id, className = '', children, ...rest }, ref) => (
  <section
    ref={ref}
    id={id}
    className={`app-section ${className}`.trim()}
    {...rest}
  >
    {children}
  </section>
));

Section.displayName = 'Section';

export default Section;
